import { loadScript } from 'dashboard/helper/DOMHelpers';

export const loadFacebookSdk = async () => {
  // Check if FB is already loaded
  if (window.FB) {
    return Promise.resolve();
  }
  return loadScript('https://connect.facebook.net/en_US/sdk.js', {
    async: true,
    defer: true,
    crossOrigin: 'anonymous',
  });
};

export const initializeFacebook = (appId, apiVersion) => {
  const version = apiVersion || 'v22.0';
  return new Promise((resolve, reject) => {
    if (!appId) {
      reject(new Error('WhatsApp App ID is not configured'));
      return;
    }

    const init = () => {
      window.FB.init({
        appId,
        autoLogAppEvents: true,
        xfbml: true,
        version,
      });
      resolve();
    };

    // If FB is already loaded and initialized
    if (window.FB && typeof window.FB.init === 'function') {
      init();
    } else {
      // Wait for FB SDK to load
      window.fbAsyncInit = init;
      // Also check periodically in case fbAsyncInit doesn't fire
      let attempts = 0;
      const maxAttempts = 50; // 5 seconds max wait
      const checkFB = setInterval(() => {
        attempts += 1;
        if (window.FB && typeof window.FB.init === 'function') {
          clearInterval(checkFB);
          init();
        } else if (attempts >= maxAttempts) {
          clearInterval(checkFB);
          reject(new Error('Facebook SDK failed to load'));
        }
      }, 100);
    }
  });
};

export const isValidBusinessData = businessData => {
  return businessData && businessData.business_id && businessData.waba_id;
};

export const createMessageHandler = onEmbeddedSignupData => {
  return event => {
    if (!event.origin.endsWith('facebook.com')) return;

    try {
      let data;
      if (typeof event.data === 'string') {
        data = JSON.parse(event.data);
      } else if (typeof event.data === 'object' && event.data !== null) {
        data = event.data;
      } else {
        return;
      }

      if (data.type === 'WA_EMBEDDED_SIGNUP') {
        onEmbeddedSignupData(data);
      }
    } catch {
      // Ignore non-JSON or irrelevant messages
    }
  };
};

export const initWhatsAppEmbeddedSignup = configId => {
  return new Promise((resolve, reject) => {
    window.FB.login(
      response => {
        if (response.authResponse && response.authResponse.code) {
          resolve(response.authResponse.code);
        } else if (response.error) {
          reject(new Error(response.error));
        } else {
          reject(new Error('Login cancelled'));
        }
      },
      {
        config_id: configId,
        response_type: 'code',
        override_default_response_type: true,
        extras: {
          setup: {},
          featureType: 'whatsapp_business_app_onboarding',
          sessionInfoVersion: '3',
        },
      }
    );
  });
};

export const setupFacebookSdk = async (appId, apiVersion) => {
  const version = apiVersion || 'v22.0';
  await loadFacebookSdk();
  await initializeFacebook(appId, version);
};
